import NosOutils from './Outils-formation.js'

export default function content_communication() {
    const ContentCommunication =
        <>
            <div className='contentContainer contentCommunication'>
                <div className='titreProjet'>
                    <h5 style={{ fontWeight: 'bold', marginBottom: '20px' }}>Affûtez votre message pour une visibilité maximale</h5>
                </div>
                <div>
                    <div className='mandat'>
                        <p className="vertical-timeline-element-subtitle">Nous déployons des stratégies innovantes pour dynamiser vos communications internes et externes, et pour soutenir la gestion du changement.</p>
                    </div>
                </div>
                <div>
                    <div className='imageOfproject'>
                        <div className='iframeWrapper'>
                            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}><iframe src="https://player.vimeo.com/video/1036047346?h=3423f74c82&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }} title="BIXI_INTRO_v2_1920x1080_20mbps"></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>
                        </div>
                    </div>
                    <div className='outil-2'>
                        <div className='solution-body-communication'>
                            <NosOutils />
                        </div>
                    </div>
                </div>
            </div>
        </>

    return ContentCommunication;
}